import * as React from "react";
import { createClasses } from "@bloomberg/media-ui-core";

import styles from "./styles.module.css";
import { HEADLINE_SIZE } from "~types/types";

interface HeadlineProps {
  text: string;
  url?: string;
  className?: string;
  forceLinking?: boolean;
  size?: string;
  preamble?: React.ReactNode;
}

interface HeadlineContentProps {
  url?: string;
  forceLinking?: boolean;
  children: React.ReactNode;
}

export const formatHeadline = (headline: string) => {
  let formattedHeadline = String(headline);

  formattedHeadline = formattedHeadline.replace(/: Markets Wrap/, "");
  formattedHeadline = formattedHeadline.replace(/\(Audio\)/i, "");
  formattedHeadline = formattedHeadline.replace(/\(video\)/i, "");
  formattedHeadline = formattedHeadline.replace(/\(podcasts?\)/i, "");
  formattedHeadline = formattedHeadline.replace(/\s+/g, " ");

  return formattedHeadline;
};

function HeadlineContent({
  url,
  children,
  forceLinking,
}: HeadlineContentProps) {
  const optionalDataAttributes = {} as Record<string, string | number>;

  if (url && forceLinking) {
    return (
      <a {...optionalDataAttributes} href={url}>
        {children}
      </a>
    );
  }

  return <span>{children}</span>;
}

function Headline({
  text,
  url,
  className,
  preamble,
  forceLinking,
  size = HEADLINE_SIZE.LARGE,
}: HeadlineProps) {
  return (
    <div
      className={createClasses(
        styles.headline,
        {
          [styles.forceLinking]: Boolean(forceLinking),
          [styles.extraLarge]: size === HEADLINE_SIZE.EXTRA_LARGE,
          [styles.large]: size === HEADLINE_SIZE.LARGE,
          [styles.small]: size === HEADLINE_SIZE.SMALL,
          [styles.fullZone]: size === HEADLINE_SIZE.FULL_ZONE,
          [styles.medium]: size === HEADLINE_SIZE.MEDIUM,
        },
        className
      )}
      data-component="headline"
      data-testid="headline"
    >
      <HeadlineContent url={url} forceLinking={forceLinking}>
        {preamble}
        {formatHeadline(text)}
      </HeadlineContent>
    </div>
  );
}

export default Headline;
